<template>
  <div
    class="un-supported-materials"
    :class="open ? 'un-supported-materials--open' : ''"
  >
    <div
      @click="open = false"
      :class="open ? 'un-supported-materials--backdrop' : ''"
    ></div>

    <div v-if="open" class="un-supported-materials__content">
      <div class="un-supported-materials__list">
        <a-collapse
          accordion
          v-for="item in unSupportedMaterials"
          :key="item.device"
        >
          <a-collapse-panel :key="item.device" :header="item.device">
            <div class="un-supported-materials__list-grid">
              <div v-for="material in item.materials" :key="material">
                <mockup-preview
                  class="mockup-preview"
                  :hideHeader="true"
                  :material="material"
                  :stamps="[null]"
                  :width="100"
                  :height="100"
                />
              </div>
            </div>
          </a-collapse-panel>
        </a-collapse>
      </div>

      <!-- <a-button
        class="un-supported-materials__btn"
        type="primary"
        icon="save"
        size="large"
        block
      >
        Save
      </a-button> -->
    </div>
    <div v-else>
      <a-button
        class="un-supported-materials__floating-btn"
        type="primary"
        icon="save"
        size="large"
        @click="open = true"
      >
        Unsupporteds Materials
      </a-button>
    </div>
  </div>
</template>

<script>
import MockupPreview from "@/components/mockup-preview/MockupPreview.vue";

export default {
  components: { MockupPreview },
  props: {
    unSupportedMaterials: Array,
  },
  data() {
    return {
      open: false,
    };
  },
};
</script>

<style lang="scss" scoped>
.un-supported-materials {
  .un-supported-materials__content {
    position: absolute;
    top: 0;
    bottom: 0;
    right: 0;
    padding: 20px;
    background: #fff;
    width: 50vw;

    .un-supported-materials__list {
      height: calc(100vh - 100px);
      overflow: auto;

      .un-supported-materials__list-grid {
        display: flex;
        flex-wrap: wrap;
        justify-content: center;
        width: 100%;
      }
    }

    .un-supported-materials__btn {
      float: right;
      margin-top: 20px;
    }
  }

  .un-supported-materials__floating-btn {
    position: fixed;
    bottom: 0;
    right: 0;
    margin: 20px;
  }
}

.un-supported-materials--open {
  position: fixed;
  top: 0;
  bottom: 0;
  right: 0;
  left: 0;
  z-index: 10;

  .un-supported-materials--backdrop {
    width: 100%;
    height: 100%;
    background: rgba($color: #000, $alpha: 0.5);
  }
}
</style>
